import React from 'react'
import FormCheck from 'react-bootstrap/FormCheck'
import { RadioProps } from './types'

export const Radio = (props: RadioProps) => {
    const { value, name, checked, label, onClick } = props

    return (
        <>
            <FormCheck
                type="radio"
                label={label}
                checked={checked}
                onChange={onClick}
                value={value}
                name={name}
            />
        </>
    )
}
